<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Линии метро</div>
        </div>
    </div>
    <div class="filter-table">
        <div class="filter-table__input-wrap search-control">
            <input @keyup.enter="onSearch()" @keyup.delete="onDeleteSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск">
            <button @click="onSearch()" class="search-control__input-btn reset-btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5"
                        stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

<!--        <div class="filter-table__list-wrap">-->
<!--            <ul class="filter-table__list">-->
<!--                <li class="filter-table__item">-->
<!--                    <v-select v-model="brand"-->
<!--                              :options="brands"-->
<!--                              @update:modelValue="onChangeBrand"-->
<!--                              :reduce="name => name.id"-->
<!--                              label="name"-->
<!--                              :searchable="false"-->
<!--                              :deselectFromDropdown="false"-->
<!--                              :appendToBody="true"-->
<!--                              :calculate-position="withPopper"-->
<!--                              :clearable="false"-->
<!--                              class="ftoggle">-->
<!--                    </v-select>-->
<!--                </li>-->
<!--            </ul>-->
<!--        </div>-->
    </div>

    <div class="table-responsive">
        <table class="table">
            <thead>
            <tr>
                <th v-for="th in thead">{{ th }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in tbody">
                <td>
                    <div
                        :style="{backgroundColor: row.tbody.color}"
                        class="marker marker_16px">
                    </div>
                </td>
                <td>
                    <span class="line-name__text">{{ row.tbody.name }}</span>
                </td>
                <td>{{ row.tbody.city }}</td>
            </tr>
            </tbody>
        </table>
    </div>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import Lines from '../../../../models/Metro/Lines';
import PaginationElement from "../../../../elements/PaginationElement";
import ChangePage from "../../../../helpers/ChangePage";

export default {
    name: 'LinesComponent',
    components: { PaginationElement },
    props: {
        route_list: String,
        route_brands_list: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            brand: 'Бренд',
            brands: [],
            selected_brand : null,
            lines: new Lines({
                route_list: this.route_list,
            }),
            search: '',
            thead: [
                'Цвет',
                'Название линии',
                'Город'
            ],
            tbody: [],
            count: 1,
            limit: 9999,
            page: 1,
        };
    },
    methods: {
        loadTable: async function () {
            let response = await this.lines.loadTable(this.page, this.limit, this.search);
            this.tbody = response.tbody;
            this.count = response.pages;
            if (this.page > 1 && this.tbody.length === 0) {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
        onChangeBrand: async function (brand_id) {
            this.selected_brand = brand_id;
            await this.loadTable();
        },
        onSearch: async function () {
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearch: async function () {
            if (this.search.trim() == '') {
                this.page = 1;
                await this.loadTable()
            }
        },
    },
    mounted () {
        this.loadTable();
    }
};
</script>
<style scoped>
    .line-name__text {
        padding-left: 5px;
    }
</style>
